// src/keycloak.ts
import type KeycloakFactory from 'keycloak-js';
import environment from './environment';

// Support both ESM default export and CommonJS module shape.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const keycloakModule = require('keycloak-js');

const Keycloak: typeof KeycloakFactory =
  (keycloakModule && keycloakModule.default) || keycloakModule;

const keycloak = new Keycloak({
  url: environment.KEYCLOAK_URL,
  realm: environment.REALM,
  clientId: environment.KEYCLOAK_CLIENT_ID,
});

// Enable logging for debugging cookie/auth issues
if (
  process.env.NODE_ENV === 'development' ||
  window.location.hostname.includes('acc.app.offiweb.be')
) {
  keycloak.onTokenExpired = () => {
    console.log('[Keycloak] Token expired');
  };
  keycloak.onAuthError = (error) => {
    console.error('[Keycloak] Auth error:', error);
  };
  keycloak.onAuthSuccess = () => {
    console.log('[Keycloak] Auth success');
  };
}

export default keycloak;
